import React from 'react';

var text = {
    "WMTS": <span>服務介接網址:<a href="https://ntmap.nantou.gov.tw/wmts" target="_blank" rel="noopener noreferrer">https://ntmap.nantou.gov.tw/wmts</a><br />
        本系統提供WMTS 發布服務的圖層。使用者無需申請，即可利用符合OGC WMTS軟體介接本系統圖資套疊。
    </span>,
    "WMS": <span>服務介接網址：<a href="https://ntmap.nantou.gov.tw/wms" target="_blank" rel="noopener noreferrer">https://ntmap.nantou.gov.tw/wms</a><br />
        本系統提供WMS發布服務的圖層。使用者無需申請，即可利用符合OGC WMS軟體介接本系統圖資套疊。<br />
        各圖層之WMS服務規格可透過GetCapabilities請求取得，<br />如：https://ntmap.nantou.gov.tw/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.0.0</span>,
    "I3S": <span>I3S服務清單網址:<a href="https://i3s.nlsc.gov.tw/i3s/Service" target="_blank" rel="noopener noreferrer">https://i3s.nlsc.gov.tw/i3s/Service</a></span>,
    "3DTiles": <span>3D Tiles服務清單網址:<a href="https://3dtiles.nlsc.gov.tw/tiles3d/Service" target="_blank" rel="noopener noreferrer">https://3dtiles.nlsc.gov.tw/tiles3d/Service</a></span>
}

export default text;